module.exports = __webpack_public_path__ + "static/media/MyInstituteSmall.3db4dc52.svg";